import type { PromptDataProfileDto } from "../../types/PromptDataProfileDto";
import type { PromptDataProfileEntity } from "../../types/PromptDataProfileEntity";

export const PromptDataProfileEntityToDto = ({ ...rest }: Readonly<PromptDataProfileEntity>): PromptDataProfileDto => {
    return { ...rest };
};
